var elementHasProp = function elementHasProp(el, name) {
  return el && el.props && !!el.props[name];
};

export default elementHasProp;